import React from 'react'
import Chip from '@mui/material/Chip'
import { EVIDENCE_STATUS } from '../severity'

const EvidenceStatusChip = ({ status, ...props }) => {
  const config = EVIDENCE_STATUS[status] || { label: status, color: 'default' }
  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
      sx={{ borderRadius: 1, fontWeight: 700 }}
      {...props}
    />
  )
}

export default EvidenceStatusChip
